let navDkCtas = $('.main-header').find('.main-nav').find('.menu-item a[data-target]');
//let navDkElem = $('body').find('.subnav-dk[data-parent]');
let menuIsOver = false;
let settimeoutover = null;
let item_bk = null;
const _body = $('body');
const fixedNav = $('.fixed-dk-nav')
let menuIsOpen;
if (navDkCtas) {
  navDkCtas.each((i, item) => {
    $(item).on('mouseover', function (e) {
      e.preventDefault();
      if ($(this).parent().siblings().children('a[data-target]').hasClass('current')) {
        $(this).parent().siblings().children('a[data-target]').removeClass('current');
        menuIsOpen = true;
      } else menuIsOpen = false;

      $(this).addClass('current');
      if (!menuIsOpen) {
        $('.fixed-dk-nav').addClass('is-open');
        _body.addClass('no-scroll');
        _body.hasClass('body-section-black') ? _body.addClass('body-scroll') : null
        _body.addClass('body-open-menu');
      }
      window.anchor_active = this.parentElement;
      _body.find('.subnav-dk[data-parent]').removeClass('is-current')
      let itemShow = _body.find('.subnav-dk[data-parent=' + $(this).attr("data-target") + ']');
      $(itemShow).addClass('is-current');
      $(itemShow).addClass('is-current').parent().addClass('current-menu-item');
      this.is_over = true;
      //navDkElem.css('display', 'none')



    })
    $(item).on('mouseleave', function (e) {
      e.preventDefault();
      item_bk = this;
      if ($(this).parent().siblings().children('a[data-target]').hasClass('current')) {
        $(this).parent().siblings().children('a[data-target]').removeClass('current');
        menuIsOpen = true;
      } else menuIsOpen = false;

      if (settimeoutover) {
        clearTimeout(settimeoutover);
      }
      settimeoutover = setTimeout(() => {
        if ($(item).hasClass('current') && !menuIsOver) {
          closeNav();
        }
      }, 100)
      this.is_over = false;

    })
  })
}
fixedNav.on('mouseover', function () {
  menuIsOver = true;
})
fixedNav.on('mouseleave', function () {
  menuIsOver = false;
  if (settimeoutover) {
    clearTimeout(settimeoutover);
  }
  if(item_bk.is_over){
    return true;
  }
  if ($(item_bk).parent().siblings().children('a[data-target]').hasClass('current')) {
    $(item_bk).parent().siblings().children('a[data-target]').removeClass('current');
    menuIsOpen = true;
  } else menuIsOpen = false;
    if ($(item_bk).hasClass('current') && !menuIsOver) {
      closeNav()
    }
})


function closeNav() {
  $(item_bk).removeClass('current');
  let itemShow = _body.find('.subnav-dk[data-parent=' + $(item_bk).attr("data-target") + ']');
  $(itemShow).removeClass('is-current');
  window.anchor_active = window.anchor_Lastactive;
  if (!menuIsOpen) {
    $('.fixed-dk-nav').removeClass('is-open');
    _body.removeClass('body-open-menu');
    _body.removeClass('no-scroll');
    _body.hasClass('body-section-black') ? _body.removeClass('body-scroll') : null
  }
}


let navTab = $('.left_list ul li');
if (navTab) {
  navTab.each((i, item) => {
      $(item).on('click', (e) => {
        e.preventDefault();
        if (!$(item).hasClass('active')) {
          navTab.removeClass('active');
          $(item).addClass('active');
          let itemSblings = $(item).parents().find('.sub-left__menu').siblings('.sub-right').find('.content-tabs');
          itemSblings.removeClass('is-current')
          let itemShow = itemSblings.filter('[id=' + $(item).attr("data-tabs") + ']');
          $(itemShow).addClass('is-current');
        }
      })
    }
  )
}

let navTabSousMenu = $('.content-tabs .tabs_wrap ul li');
if (navTabSousMenu) {
  navTabSousMenu.each((i, item) => {
    $(item).on('click', (e) => {
      e.preventDefault();
      if (!$(item).hasClass('active')) {
        $(item).siblings().removeClass('active');
        $(item).addClass('active');
        let itemSblings = $(item).parents('.tabs_wrap').siblings('.tabs_content').find('.menu-item');
        itemSblings.removeClass('is-current')

        let itemShow = itemSblings.filter('[id=' + $(item).attr("data-tabs") + ']');
        $(itemShow).addClass('is-current');
      }
    })
  })
}



// WEBPACK FOOTER //
// ./scripts/menu.js